/*
	After some async processes, we sometimes receive notifications that there are new Versions
	imported to a library, so we will dispatch a reload.
*/

import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { useOnMountFTMessage } from "hooks/Notification";

import { Creatives } from "reducers/Creatives";

import { JCRM_SOCKET } from "utils/constants";

export function useCreativesSocket() {
	const dispatch = useDispatch();
	const { libraryId } = useParams();

	useOnMountFTMessage(({ detail }) => {
		let { message } = detail;

		if(message.origin === JCRM_SOCKET){
			if(!/success/gi.test(message.status)){ return; }

			if (/import versions/gi.test(message.task)) {
				if (!message.data?.response?.changes?.creatives) { return; }

				const { creatives } = message.data.response.changes;

				if (creatives.length < 1) { return; }

				const reqLibraryId = message.data?.creativeLibrary?.id;

				if (parseInt(libraryId) !== parseInt(reqLibraryId)) { return; }

				dispatch(Creatives.loadCreatives(libraryId));
			}

			if (/creative status transition/gi.test(message.task)) {
				const { data = {} } = message;
				const { library = {}, creatives = [], approval = "" } = data;

				if (!creatives.length || !approval) { return; }

				const reqLibraryId = library.id;

				if (parseInt(libraryId) !== parseInt(reqLibraryId)) { return; }

				dispatch(Creatives.updateApprovalsFromSocket(creatives, approval));
			}
		}
	});
}

export function CreativesSocketListener({ children }){
	useCreativesSocket();

	return children;
}
